import { useCallback, useEffect, useMemo, useState } from "react";
import { useField } from "formik";
import Utils from "../../../utils/utils";

const RadioButtonList = ({ name, onSelect, heading }) => {
    const [data, setData] = useState([]);
    const [selectedValue, setSelectedValue] = useState(Utils.getDomain());

    const [field] = useField(name);

    useEffect(() => {
        if (field.value) {
            setData([...field.value]);
        }
    }, [field.value]);

    const handleSelect = useCallback((id) => {
        setSelectedValue(id);
        onSelect(id);
    }, [setSelectedValue, onSelect]);

    const renderButtons = useMemo(() => (
        data.map((element, index) => (
            <div className="form-check clickable" key={index} onClick={() => handleSelect(element._id)}>
                <input className="form-check-input clickable" name="domainRadio" type="radio"
                    onChange={() => handleSelect(element._id)}
                    checked={element._id === selectedValue}></input>
                <label className="form-check-label clickable">{element.name}</label>
            </div>
        ))
    ), [data, selectedValue, handleSelect]);

    return (
        <div className="">
            <label htmlFor="list-items" className="form-label h6 d-block">{heading}</label>
            {renderButtons}
        </div>
    );
};

export default RadioButtonList;